// extracted by mini-css-extract-plugin
export default {"loader":"loader-view_loader__9shXT","pulse":"loader-view_pulse__PuYb3"};